export const ExclamationSquareIcon = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3016_11141)">
        <path
          d="M14.4995 0.999023C14.7647 0.999023 15.0191 1.10438 15.2066 1.29192C15.3942 1.47945 15.4995 1.73381 15.4995 1.99902V13.999C15.4995 14.2642 15.3942 14.5186 15.2066 14.7061C15.0191 14.8937 14.7647 14.999 14.4995 14.999H2.49951C2.2343 14.999 1.97994 14.8937 1.7924 14.7061C1.60487 14.5186 1.49951 14.2642 1.49951 13.999V1.99902C1.49951 1.73381 1.60487 1.47945 1.7924 1.29192C1.97994 1.10438 2.2343 0.999023 2.49951 0.999023H14.4995ZM2.49951 -0.000976562C1.96908 -0.000976562 1.46037 0.209737 1.0853 0.58481C0.710225 0.959883 0.499512 1.46859 0.499512 1.99902V13.999C0.499512 14.5295 0.710225 15.0382 1.0853 15.4132C1.46037 15.7883 1.96908 15.999 2.49951 15.999H14.4995C15.0299 15.999 15.5387 15.7883 15.9137 15.4132C16.2888 15.0382 16.4995 14.5295 16.4995 13.999V1.99902C16.4995 1.46859 16.2888 0.959883 15.9137 0.58481C15.5387 0.209737 15.0299 -0.000976562 14.4995 -0.000976562H2.49951Z"
          fill="#F03C48"
        />
        <path
          d="M7.50151 10.999C7.50151 10.8677 7.52738 10.7377 7.57763 10.6163C7.62789 10.495 7.70155 10.3848 7.7944 10.2919C7.88726 10.1991 7.9975 10.1254 8.11883 10.0751C8.24015 10.0249 8.37019 9.99902 8.50151 9.99902C8.63283 9.99902 8.76287 10.0249 8.8842 10.0751C9.00552 10.1254 9.11576 10.1991 9.20862 10.2919C9.30148 10.3848 9.37514 10.495 9.42539 10.6163C9.47565 10.7377 9.50151 10.8677 9.50151 10.999C9.50151 11.2642 9.39615 11.5186 9.20862 11.7061C9.02108 11.8937 8.76673 11.999 8.50151 11.999C8.2363 11.999 7.98194 11.8937 7.7944 11.7061C7.60687 11.5186 7.50151 11.2642 7.50151 10.999ZM7.59951 4.99402C7.58619 4.86786 7.59955 4.74032 7.63871 4.61965C7.67787 4.49899 7.74197 4.3879 7.82683 4.29361C7.9117 4.19932 8.01544 4.12392 8.13132 4.07231C8.24721 4.02069 8.37265 3.99402 8.49951 3.99402C8.62637 3.99402 8.75181 4.02069 8.8677 4.07231C8.98359 4.12392 9.08733 4.19932 9.17219 4.29361C9.25706 4.3879 9.32115 4.49899 9.36031 4.61965C9.39947 4.74032 9.41283 4.86786 9.39951 4.99402L9.04951 8.50102C9.03775 8.63879 8.97471 8.76714 8.87287 8.86066C8.77102 8.95418 8.63778 9.00608 8.49951 9.00608C8.36124 9.00608 8.228 8.95418 8.12616 8.86066C8.02431 8.76714 7.96127 8.63879 7.94951 8.50102L7.59951 4.99402Z"
          fill="#F03C48"
        />
      </g>
      <defs>
        <clipPath id="clip0_3016_11141">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
